import React from 'react';
import { Button, Flex } from '@chakra-ui/react';

const tabData = [
    {
        id: 'data',
        title: 'Station Data',
    },
    {
        id: 'info',
        title: 'Station Info',
    },
];

const StationTabs = (props) => {
    const { currentTab, setCurrentTab } = props;

    return (
        <div style={{ width: '100%' }}>
            <Flex bg='#fff' pb={4} align='center' justify='center'>
                {tabData.map((tab) => (
                    <Button
                        key={tab.id}
                        variant='solid'
                        onClick={() => setCurrentTab(tab.id)}
                        borderRadius='99px'
                        bg={currentTab === tab.id ? 'teal.100' : ''}
                        color={currentTab === tab.id ? 'teal.700' : 'gray.800'}
                        fontWeight={500}
                        px={8}
                        size='md'
                        _hover={{
                            bg: 'teal.100',
                        }}
                        _focus={{
                            bg: 'teal.100',
                        }}
                        _active={{
                            bg: 'teal.100',
                        }}
                    >
                        {tab.title}
                    </Button>
                ))}
            </Flex>
        </div>
    );
};

export default StationTabs;
